import { login, getInfo } from "@/api/auth";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";

const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
    role: "",
    userInfo: null,
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLE: (state, role) => {
    state.role = role;
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
};

const actions = {
  // 用户登录
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password })
        .then((response) => {
          const { data } = response;
          // 处理API返回的admin_info字段
          const adminInfo = data.admin_info || data.admin;
          commit("SET_TOKEN", data.token);
          commit("SET_USER_INFO", adminInfo);
          commit("SET_NAME", adminInfo.username);
          commit("SET_ROLE", adminInfo.role || "admin");
          setToken(data.token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then((response) => {
          const { data } = response;

          if (!data) {
            reject("验证失败，请重新登录。");
          }

          const { username, role, avatar_url } = data;

          commit("SET_NAME", username);
          commit("SET_AVATAR", avatar_url || "");
          commit("SET_ROLE", role);
          commit("SET_USER_INFO", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 用户登出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      try {
        // JWT token系统，直接清除本地token即可，无需调用API
        removeToken(); // 删除本地token
        resetRouter(); // 重置路由
        commit("RESET_STATE"); // 重置状态
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  // 删除token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // 必须先删除token
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
